import DataLoadError, {
  DataLoadDefaultErrors,
} from "../data-load-error/data-load-error";
import dataLoadErrorFactory from "../data-load-error/data-load-error.factory";
import HttpError from "../http/http.error";
import httpHelper from "../http/http.helper";

const handleError = (error: HttpError): DataLoadDefaultErrors => {
  switch (error) {
    case HttpError.OFFLINE:
      return dataLoadErrorFactory.createOfflineError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const handleCustomError = <T extends DataLoadError<any, any>>(
  error: HttpError | T,
): T => {
  if (!httpHelper.checkIsHttpError(error)) {
    return error;
  }

  switch (error) {
    case HttpError.OFFLINE:
      return dataLoadErrorFactory.createOfflineError() as T;
    default:
      return dataLoadErrorFactory.createUnexpectedError() as T;
  }
};

const handleErrorFactory = {
  handleError,
  handleCustomError,
};

export default handleErrorFactory;
